import { useContext } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import MyTextField from "../../components/inputs/MyTextField";
import MyButton from "../../components/MyButton";
import MyTextArea from "../../components/inputs/MyTextArea";
import { useUser } from "../../hooks/useUser";
import { SiteContext } from "../../context/SiteProvider";
import { AuthContext } from "../../context/AuthProvider";
import { PopupContext } from "../../context/PopupProvider";
import WithdrawMemberDialog from "./components/WithdrawMemberDialog";

const MyPage05 = () => {
  const { setLoadingScreen } = useContext(SiteContext);
  const { profile, setProfile, isAuthenticated } = useContext(AuthContext);
  const { openPopup } = useContext(PopupContext);
  const { withdrawMutation } = useUser();
  const navigate = useNavigate();

  const initValues = {
    password: "",
    rePassword: "",
    reason: "",
  };

  const validationSchema = yup.object({
    password: yup.string().required("필수 입력 항목입니다."),
    rePassword: yup
      .string()
      .required("필수 입력 항목입니다.")
      .oneOf([yup.ref("password")], "비밀번호가 일치하지 않습니다."),
    reason: yup.string().required("필수 입력 항목입니다."),
  });

  const methods = useForm({
    defaultValues: initValues,
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    const payload = {
      userKeyType: "Id",
      userKeyCode: profile.id,
      password: data.password,
      reason: data.reason,
    };

    openPopup(
      <WithdrawMemberDialog
        onSubmit={() => {
          setLoadingScreen(true);
          withdrawMutation.mutate(payload, {
            onSuccess: () => {
              alert("계정이 삭제되었습니다.");
              setProfile({});
              localStorage.removeItem("userId");
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");

              navigate("/");
            },
            onError: (err) => {
              if (err.data.code === "INVALID_CREDENTIAL") {
                alert("비밀번호가 정확하지 않습니다.");
                methods.setError("password", {
                  message: "비밀번호가 정확하지 않습니다.",
                });
                return;
              } else {
                alert("오류가 발생했습니다.");
              }
            },
            onSettled: () => {
              setLoadingScreen(false);
            },
          });
        }}
      />
    );
  };

  return isAuthenticated ? (
    <div className="flex justify-center">
      <div className="w-full max-w-[600px] pt-10">
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(onSubmit)}
            className="flex flex-wrap gap-x-[2%] gap-y-5"
          >
            <div className="w-full flex flex-col">
              <label htmlFor="reason" className="w-[100px] font-semibold">
                탈퇴 사유 <span className="text-error">*</span>
              </label>
              <div className="w-full">
                <MyTextArea id="reason" name="reason" rows="4" />
              </div>
            </div>

            <div className="w-full flex flex-col">
              <label htmlFor="password" className="w-[100px] font-semibold">
                비밀번호 <span className="text-error">*</span>
              </label>
              <div className="w-full">
                <MyTextField
                  id="password"
                  type="password"
                  name="password"
                  placeholder="현재 비밀번호를 입력하세요."
                />
              </div>
              <div className="w-full mt-5">
                <MyTextField
                  id="rePassword"
                  type="password"
                  name="rePassword"
                  placeholder="비밀번호를 한번 더 입력해주세요."
                />
              </div>
            </div>

            <MyButton
              variant="contained"
              color="primary"
              className="w-[49%] font-semibold h-[56px]"
              type="submit"
              size="small"
            >
              탈퇴하기
            </MyButton>
            <MyButton
              variant="outlined"
              className="w-[49%] h-[56px]"
              size="small"
            >
              <span>취소</span>
            </MyButton>
          </form>
        </FormProvider>
      </div>
    </div>
  ) : null;
};

export default MyPage05;
